<template>
    <div class="navBackground">
        <div class="topNav">
            <RouterLink to="/" class="logo">
                <img src="../assets/logo.png" alt="">
            </RouterLink>
            <RouterLink to="/"  class="nav" id="home">
                首页
            </RouterLink>
            <!-- <div id="nanoMenu" class="nav width150"  @mouseenter="showSecondMenu('nanoMenu')" @mouseleave="hideSecondMenu('nanoMenu')">
                <RouterLink to="/nano" id="nano">
                    纳米微软虚拟实验室
                </RouterLink>
                <div class="secondMenu hide">
                    <i class="el-icon-caret-top arrowUp"></i>
                    <div class="topBG"></div>
                    <ul>
                        <li><RouterLink to="/nano?goto=p0">产品中心</RouterLink></li>
                        <li><RouterLink to="/nano?goto=p1">产品演示</RouterLink></li>
                        <li><RouterLink to="/nano?goto=p2">解决方案</RouterLink></li>
                        <li><RouterLink to="/nano?goto=p3">客户案例</RouterLink></li>
                    </ul>
                </div>
            </div>         -->
            <a target="_blank" :href="vrdjUrl" class="nav width180">
                Feitem数智化平台
            </a>    
            <RouterLink  to="/equipment" class="nav" id="equipment">
                实验设备
            </RouterLink>
            <!-- <RouterLink  to="/project" class="nav" id="project">
                项目申报
            </RouterLink> -->
            <RouterLink  to="/news" class="nav" id="news">
                新闻中心
            </RouterLink>
            <RouterLink  to="/about" class="nav" id="about">
                关于我们
            </RouterLink>
            <!-- <RouterLink to="/wenjuan" class="nav" id="wenjuan">
                问卷调查
            </RouterLink> -->
        </div>
        
        <div class="mobNav">
            <div class="logoBox">
                <img src="../assets/logo.png" alt="" @click="linkTo('/')"/>
            </div>
            <div class="mobMenuTop" @click="mobMenuVisible = !mobMenuVisible">
                <i class="el-icon-s-fold"></i>
            </div>
            <div v-if="$root.isMob && ($route.path == '/about' || $route.path == '/news' || $route.path == '/project' || $route.path == '/nano')" class="childMenuCtrl" @click="isShowChildMenu = !isShowChildMenu">
                <i class="el-icon-caret-left"></i>
            </div>
            <div class="childMenuList">                
                <div v-if="$route.path == '/about'">
                    <div class="nav" @click="scrollTo('companyIntro',51)">公司介绍</div>
                    <div class="nav" @click="scrollTo('companyHornor',51)">公司荣誉</div>
                    <div class="nav" @click="scrollTo('map',51)">联系我们</div>
                    <div class="nav" @click="scrollTo('joinUs',51)">诚聘英才</div>
                </div>        
                <div v-if="$route.path == '/news'">
                    <div class="nav active" @click="$root.changeContentType(1,$event)">公司新闻</div>
                    <div class="nav" @click="$root.changeContentType(2,$event)">行业咨询</div>
                </div>       
                <div v-if="$route.path == '/project'">
                    <div v-for="(item,index) in projectCateList" :key="item.id" :id="'type'+item.id" :class="index == 0 ? 'nav active' : 'nav'" @click="$root.changeContentType(item.id,$event)">
                        {{ item.title }}
                    </div>
                </div>     
                <div v-if="$route.path == '/nano'">
                    <div class="nav active" id="nano1" @click="$root.changeContentType(1,$event)">产品中心</div>
                    <div class="nav" id="nano2" @click="$root.changeContentType(2,$event)">产品演示</div>
                    <div class="nav" id="nano3" @click="$root.changeContentType(3,$event)">解决方案</div>
                    <div class="nav" id="nano4" @click="$root.changeContentType(4,$event)">客户案例</div>
                </div>  
            </div>
            <div class="mobMenuContect" @click="linkTo('https://work.weixin.qq.com/kfid/kfc566d985476107923')">
                <i class="el-icon-service"></i>
            </div> 
            <div class="mobMenu" @click="mobMenuVisible = !mobMenuVisible">
                <i class="el-icon-s-fold"></i>
            </div>            
            <el-drawer
            title="Menus"
            :visible.sync="mobMenuVisible"
            :direction="'ltr'"
            :size="'70%'"
            :append-to-body="true">
                <el-menu :default-active="currentIndex">
                    <el-menu-item index="home" @click="linkTo('/')">
                        <i class="el-icon-menu"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <!-- <el-submenu index="nano">
                        <template slot="title">
                        <i class="el-icon-s-opportunity"></i>
                        <span>纳米微观虚拟实验室</span>
                        </template>
                        <el-menu-item index="gotop0"  @click="linkTo('/nano?goto=p0')">产品中心</el-menu-item>
                        <el-menu-item index="gotop1" @click="linkTo('/nano?goto=p1')">产品演示</el-menu-item>
                        <el-menu-item index="gotop2" @click="linkTo('/nano?goto=p2')">解决方案</el-menu-item>
                        <el-menu-item index="gotop3" @click="linkTo('/nano?goto=p3')">客户案例</el-menu-item>
                    </el-submenu> -->
                    <el-menu-item index="equipment" @click="linkTo('/productsList')">
                        <i class="el-icon-s-tools"></i>
                        <span slot="title">实验设备</span>
                    </el-menu-item>
                    <el-menu-item index="equipment" @click="linkTo(vrdjUrl,'_blank')">
                        <i class="el-icon-s-platform"></i>
                        <span slot="title">Feitem数智化平台</span>
                    </el-menu-item>
                    <!-- <el-menu-item index="project" @click="linkTo('/project')">
                        <i class="el-icon-document"></i>
                        <span slot="title">项目申报</span>
                    </el-menu-item> -->
                    <el-menu-item index="news" @click="linkTo('/news')">
                        <i class="el-icon-s-comment"></i>
                        <span slot="title">新闻中心</span>
                    </el-menu-item>
                    <el-menu-item index="about" @click="linkTo('/about')">
                        <i class="el-icon-s-custom"></i>
                        <span slot="title">关于我们</span>
                    </el-menu-item>
                </el-menu>
            </el-drawer>
        </div>
    </div>
</template>

<script>
//静态资源导入
import websiteQR from '@/assets/img/website.png';
import serviceQR from '@/assets/img/service.png';

export default {
    name: 'topNav',
    watch: {
        '$route.path': function(){
            this.mobMenuVisible = false;
            this.isShowChildMenu = false;
            this.getPageCate();
            this.$nextTick(() => {
                this.routerCheck();
            });
        },
        'isShowChildMenu':function(){
            let childMenuCtrl = document.getElementsByClassName('childMenuCtrl')[0];
            let childMenuList = document.getElementsByClassName('childMenuList')[0];
            let icon = childMenuCtrl.getElementsByTagName('i')[0];
            if(this.isShowChildMenu){
                icon.style.transform = 'rotate(180deg)';
                childMenuCtrl.style.right = '84px';
                childMenuList.style.right = '0';
            }else{
                icon.style.transform = 'rotate(0deg)';
                childMenuCtrl.style.right = '0';
                childMenuList.style.right = '-85px';
            }
        }
    },
    data() {
        return {
            //静态资源声明S
            websiteQR:websiteQR,
            serviceQR:serviceQR,
            //静态资源声明E
            mobMenuVisible:false,
            currentIndex:'',
            isShowChildMenu:false,
            projectCateList:[],
            vrdjUrl:window.config.vrdjUrl,
        }
    },
    methods: {
        routerCheck: function(){
            let topNav = document.getElementsByClassName('topNav')[0];
            let activeMenus = topNav.getElementsByClassName('active');
            for(let i = 0; i < activeMenus.length; i++){
                activeMenus[i].classList.remove('active');
            }
            //检查当前路由
            let path = this.$route.path;
            if(path == '/'){
                //首页
                let nav = document.getElementById('home');
                nav.classList.add('active');
                this.currentIndex = 'home';
            }else if(path == '/news'||path == '/newsDetail'){
                //新闻中心
                let nav = document.getElementById('news');
                nav.classList.add('active');
                this.currentIndex = 'news';
            }else if(path == '/about'){
                //关于我们
                let nav = document.getElementById('about');
                nav.classList.add('active');
                this.currentIndex = 'about';
            }else if(path == '/project' || path == '/projectDetail'){
                //项目申报
                let nav = document.getElementById('project');
                nav.classList.add('active');
                this.currentIndex = 'project';
            }else if(path == '/equipment' || path == '/productsList' || path == '/productDetail'){
                //实验设备
                let nav = document.getElementById('equipment');
                nav.classList.add('active');
                this.currentIndex = 'equipment';
            }else if(path == '/nano'){
                //纳米微软虚拟实验室
                let nav = document.getElementById('nanoMenu');
                nav.classList.add('active');
                this.currentIndex = 'nano';
            }
        },
        // showSecondMenu: function(id){
        //     let text = document.getElementById('nano');
        //     text.style.color = '#5e8743';
        //     let nav = document.getElementById(id);
        //     let secondMenu = nav.querySelector('.secondMenu');
        //     secondMenu.classList.remove('hide');
        //     secondMenu.classList.add('show');
        // },
        // hideSecondMenu: function(id){
        //     let text = document.getElementById('nano');
        //     text.style.color = '#FFF';
        //     let nav = document.getElementById(id);
        //     let secondMenu = nav.querySelector('.secondMenu');
        //     secondMenu.classList.remove('show');
        //     secondMenu.classList.add('hide');
        // },
        linkTo(url,target="_self"){
            this.mobMenuVisible = false;
            if(url[0] == '/'){
                url = '/#'+url;
            }
            window.open(url,target);
        },
        scrollTo(id,offset=0){
            let targetPosition = document.getElementById(id).offsetTop - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'        // 平滑滚动
            });
        },
        async getProjectCategory(){
            this.projectCateList = await this.$root.getProjectCate();
        },
        getPageCate(){
            if(this.$route.path == '/project'){
                this.getProjectCategory();
            }            
        },
    },
    mounted(){
        this.routerCheck();
        this.getPageCate();
    }
}
</script>

<style lang="scss" src="@/assets/css/topNav.scss" scoped></style>